import ImageBuilding from "../../ImageBuilding/ImageBuilding";
import React from "react";

import {useTranslationContext} from "../../../../react/providers/TranslationContext";

type Props = {
    gid: number[],
    level: number,
    setSelectedBuilding?: (gid: number|null) => void,
}

export function BuildingRequirementBuilding({gid, level, setSelectedBuilding}: Props) {
    const { translate } = useTranslationContext();
    let additional = '';
    if (gid.length > 1) {
        additional = gid.slice(1).map(gid => `${translate('or_gid' + gid)}`).join(' ');
        additional = `(${additional})`;
    }

    function handleClick(e: React.MouseEvent) {
        e.preventDefault();
        setSelectedBuilding(gid[0]);
    }

    return <div className='d-flex gap-2 align-items-center'>
        <ImageBuilding gid={gid[0]} size={24} />
        <a onClick={handleClick} href=''>{translate('building_g' + gid[0])}</a> {additional} {translate('level')} <b>{level.toLocaleString()}</b>
    </div>
}
